import axios from 'axios';
export function post(url, data = {}) {
    url = '/api' + url
    return axios({
      method: 'post',
      url,
      data
  }).then(res => res.data)
}
export function get(url, data = {}) {
    url = '/api' + url
    return axios({
      method: 'get',
      url,
      params: data
  }).then(res => res.data)
}
export function put(url, data = {}) {
    url = '/api' + url
    return axios({
        method: 'put',
        url,
        data
    }).then(res => res.data)
}
export function del(url, data = {}) {
    url = '/api' + url
    return axios({
        method: 'delete',
        url,
        data
    }).then(res => res.data)
}
